# Load View
require('./index.jade')
require('./basic-analysis/basic-analysis.jade')
require('./club-filter/club-filter.jade')
require('./course-filter/course-filter.jade')
require('./detailed-analysis/detailed-analysis.jade')
require('./period-filter/period-filter.jade')
require('./scatter-data/scatter-data.jade')
require('./score-analysis/score-analysis.jade')
require('./stroke-analysis/stroke-analysis.jade')
require('./time-series-data/time-series-data.jade')

# Load Css
require('../../../sass/web/html/_score_analysis.scss')

# Load Components
require('highcharts/highcharts.src')
require('highcharts/highcharts-more.src')
require('angular')
require('angular-route')
require('angular-ui-utils')
require('angular-ui-map')
require('../../core/translation/translation-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/auth/auth-module')
require('../components/analysis-charts/analysis-charts-module')
require('../components/payment/payment-module')
require('../components/remote-api/remote-api-module')
require('../components/number/number-module')
require("../components/map/map-module")
require("../goal-settings/goal-settings-module.coffee")
require('../components/error-handler/error-handler-module')
require('../components/analyze-access/analyze-access-module')

# Load Dependencies
IndexCtrl = require('./index-controller')
PeriodFilterCtrl = require('./period-filter/period-filter-controller')
ClubFilterCtrl = require('./club-filter/club-filter-controller')
CourseFilterCtrl = require('./course-filter/course-filter-controller')
BasicAnalysisCtrl = require('./basic-analysis/basic-analysis-controller')
AnalysisService = require('./analysis-service')
DateRangePickerDirective = require('./period-filter/daterangepicker-directive')
StrokeAnalysisCtrl = require('./stroke-analysis/stroke-analysis-controller')
ScoreAnalysisCtrl = require('./score-analysis/score-analysis-controller')
TimeSeriesDataCtrl = require('./time-series-data/time-series-data-controller')
DetailedAnalysisCtrl = require('./detailed-analysis/detailed-analysis-controller')
ScatterDataCtrl = require('./scatter-data/scatter-data-controller')
ScatterDataService = require('./scatter-data/scatter-data-service')
ScatterChartDirective = require('./scatter-data/scatter-chart-directive')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-common-wrapper'
  'gnp-auth'
  'ui.map'
  'gnp-analysis-charts'
  'gnp-app-goal-settings'
  'gnp-payment'
  'gnp-remote-api'
  'gnp-error-handler'
  'gnp-number'
  'gnp-map'
  'gnp-analyze-access'
]

angular.module "gnp-app-analysis", modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider
    .when '/analysis',
      templateUrl: 'web/analysis/index.jade'
      controller: 'AnalysisCtrl'
      resolve:
        goalSettings: ['GoalAPIService', '$route', (GoalAPIService, $route) ->
          params =
            user_id: $route.current.params.user_id
          GoalAPIService.getGoalSettings(params)
        ]
        userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
          AccountService.getUserInfo() if AuthService.isSignedIn()
        ]
      title: '_ANALYSIS.TITLE'
      permission:
        signInRequired: false
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
    .translations 'en', require('./i18n/en')
    .translations 'ja', require('./i18n/ja')
  ]
  .controller 'AnalysisCtrl', IndexCtrl
  .controller 'AnalysisPeriodFilterCtrl', PeriodFilterCtrl
  .controller 'AnalysisClubFilterCtrl', ClubFilterCtrl
  .controller 'AnalysisCourseFilterCtrl', CourseFilterCtrl
  .controller 'StrokeAnalysisCtrl', StrokeAnalysisCtrl
  .controller 'ScoreAnalysisCtrl', ScoreAnalysisCtrl
  .controller 'BasicAnalysisCtrl', BasicAnalysisCtrl
  .controller 'AnalysisTimeSeriesDataCtrl', TimeSeriesDataCtrl
  .controller 'AnalysisScatterDataCtrl', ScatterDataCtrl
  .controller 'DetailedAnalysisCtrl', DetailedAnalysisCtrl
  .factory "AnalysisService", AnalysisService
  .factory "ScatterDataService", ScatterDataService
  .directive "gnpDateRangePicker", DateRangePickerDirective
  .directive "gnpScatterChart", ScatterChartDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/analysis-module.coffee